export class District {
  Country;
  District;
  Area;
  AreaDesc;
  AreaChiDesc;
  constructor() {
    this.Country = "";
    this.District = "";
    this.Area = "";
    this.AreaDesc = "";
    this.AreaChiDesc = "";
  }
}



// WEBPACK FOOTER //
// ./src/model/District.js